import { render, staticRenderFns } from "./InputHeader.vue?vue&type=template&id=f70540e6"
import script from "./InputHeader.vue?vue&type=script&lang=js"
export * from "./InputHeader.vue?vue&type=script&lang=js"
import style0 from "./InputHeader.vue?vue&type=style&index=0&id=f70540e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports